import jwtDecode from "jwt-decode";
import request from "request-promise";
import { RequestOptionsService } from "./requestOptions";
import jQuery from "jquery";

export class AuthenticationService {
  public static readToken() {
    return localStorage.getItem("tokenInfo");
  }

  public static parseToken(accessToken) {
    const decoded = jwtDecode(accessToken);
    return decoded;
  }

  public static saveToken(accessToken) {
    localStorage.setItem("tokenInfo", accessToken);
  }

  public static isAuthenticated() {
    return localStorage.tokenInfo ? true : false;
  }

  public static async getToken() {
    let accessToken = AuthenticationService.getTokenFromAttribute();
    if (!accessToken) {
      const tokenOptions = RequestOptionsService.getTokenOptions();
      const result = await request(tokenOptions);
      accessToken = JSON.parse(result).accessToken;
    }
    AuthenticationService.saveToken(accessToken);
    return accessToken;
  }

  public static async singOut() {
    localStorage.removeItem("tokenInfo");
  }

  public static getCompanyId(): string {
    return AuthenticationService.parseToken(AuthenticationService.readToken()).companyId;
  }

  private static getTokenFromAttribute() {
    const t = jQuery("beu-widget").attr("token");
    return t || null;
  }
}
